import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface PageIntroProps {
    id: string
    eyebrow: string
    title: ReactNode
    intro?: ReactNode
    aside?: ReactNode
    className?: string
}

// The opening of every inner page: a small label, a large title set off-centre, and a short note
const PageIntro: FC<PageIntroProps> = ({ id, eyebrow, title, intro, aside, className }): ReactNode => {
    return (
        <section id={id} aria-labelledby={`${id}-title`} className={cn('container-page pb-14 pt-12 md:pb-20 md:pt-20', className)}>
            <div className='grid gap-8 lg:grid-cols-12 lg:gap-8'>
                <div className='animate-in fade-in slide-in-from-bottom-3 duration-[1200ms] ease-out motion-reduce:animate-none lg:col-span-8'>
                    <p className='flex items-center gap-4 text-sm font-medium text-bark-soft'>
                        <span aria-hidden='true' className='h-px w-10 bg-pomegranate' />
                        {eyebrow}
                    </p>
                    <h1 id={`${id}-title`} className='mt-6 font-heading text-[clamp(2.7rem,6.4vw,5.6rem)] font-light leading-[0.98] tracking-[-0.025em] text-bark'>
                        {title}
                    </h1>
                </div>

                {(intro || aside) && (
                    <div className='animate-in fade-in delay-300 duration-[1200ms] ease-out fill-mode-both motion-reduce:animate-none lg:col-span-4 lg:self-end lg:pb-3'>
                        {intro && <div className='text-[1.05rem] leading-relaxed text-bark-soft'>{intro}</div>}
                        {aside}
                    </div>
                )}
            </div>
        </section>
    )
}

export default PageIntro
